import {HostBinding, ElementRef,QueryList,ViewChild,ViewChildren,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';

import {Subscription} from 'rxjs'

import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {ArticleService} from '../../services/article.service';
import {CommonService} from '../../services/common.service';
import {NewsletterService} from '../../services/newsletter.service';

declare var $ : any;

@Component({
  selector: 'app-commentreply',
  templateUrl: './commentreply.component.html',
  styleUrls: ['./commentreply.component.css']
})
export class CommentreplyComponent implements OnInit,OnChanges,OnDestroy,AfterViewInit{


  
  @HostBinding('style.width') public width: string = '100%';

  @Input() isAdmin:boolean;
  @Input() articleId: any;
  @Input() commentId: any;
  @Input() authorId: any;
  @Input() loginUser: any;
  @Input() pos: any;
  @Input() comment :any;
  @Input() replyIndx :any;
  @Input() replyId :any;

  @Output() replySubmit = new EventEmitter();

  url:any=AppSettings.API_ENDPOINT
  dropdownSettings={};
  
  dataList:any =[
    {'key':'private','value':'Private'},
    {'key':'public','value':'Public'}
  ];
 
  selectedType = [{'key':'private','value':'Private'}]

  comments:any;
  commentAttachmentName=[];
  commentToltipName =[]
  commentAttachment=[];
  commonService:any;

  constructor(private route:ActivatedRoute,cmmonService:CommonService,private msg:MessageService, private toastr: ToastrService, _router: Router,private articleService:ArticleService,private newsService:NewsletterService) {
    this.commonService=cmmonService;
   }



  ngOnInit() {

    // console.log('ranjit',this.comment,this.replyIndx)

    if(this.comment){

      this.comments = this.comment.comments
     
      this.comment.commentAttachments.map((x)=>{
        
        if(x){
          let name = x.split('/');
          this.commentAttachmentName.push(name[2])
          this.commentAttachment.push(x)
          let toltip = name[2].split('_');
          toltip.shift();
          let arr=[]

          toltip.map((y)=>{
            arr.push(y)
          })
        
          this.commentToltipName.push(arr.join('_'))
        }
        
     })
    
      if(this.comment.status!=undefined && this.comment.status =='Public'){

        this.selectedType = [{'key':'public','value':'Public'}]

      }else{

        this.selectedType = [{'key':'private','value':'Private'}]
      }
    }
    
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true	
    };


  }

  ngOnChanges(ch:SimpleChanges){

   
  }

  ngAfterViewInit(){


  }

  ngOnDestroy(){


  }

  onTypeSelect(event:any){
     
  }

  saveComment(){

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;
  
        if(!tokenA) throw 'Error in parse';
        
        if(!JSON.parse(tokenA)) throw 'Error in json parse';
      
        tokenA = JSON.parse(tokenA);

        let commentAttachmentsName =[]

        this.commentAttachmentName.map((x)=>{
          let name=x.split('.').slice(1)
          commentAttachmentsName.push(name[0])
        })
       

        let data={
          token:tokenA.token,
          article:this.articleId,
          commentReply:this.commentId,
          comments:this.comments,
          commentAttachments:this.commentAttachment,
          commentAttachmentsName: commentAttachmentsName
        
          
        }
        if(this.replyId){

          data['id']= this.replyId
        }

        if(this.selectedType[0].key == 'public'){
          data['public'] = true
        }
        
         this.articleService.commentSave(data).subscribe( (res)=>{

          if (res.status == 'success') {

            this.replySubmit.emit(true)

          }

         })


      } catch(exec){

      }

  }

  uploadAttachment($event){

    var formData = $event.target.files;
    var data = new FormData();

    let toastr =  this.toastr;
    
    $.each(formData, function(i, file) {   

     let ext = file.name.split('.').pop();


     if(ext=="pdf" || ext=="docx" || ext=="doc" || ext=="xls" || ext=="xlsx" || ext=="csv" || ext=="ppt" || ext=="pptx"){
      
      data.append('file'[i], file);

     }else{
      toastr.warning('Please choose pdf,doc,docx,xls,xlsx or csv file !', '', {timeOut: 3000}); 
     }
     
    });


    try{
      let token: any = JSON.parse(atob(localStorage.getItem('token')));
      let obj = {
          token: token,
          reqData: data
      }
      this.newsService.imageUpload(obj).subscribe((res) => {
           
          if (res.status == 'success') {

            res.files.map((x)=>{
              let name = x.path.split('/');
              this.commentAttachmentName.push(name[2])
              this.commentAttachment.push(x.path)
              let toltip = name[2].split('_');
                 toltip.shift();
                 let arr=[]

                 toltip.map((y)=>{
                   arr.push(y)
                 })
                
                 this.commentToltipName.push(arr.join('_'))
           })

          } else {
            this.toastr.error('File upload failed!', '', {timeOut: 3000}); 
          }

      })
    }catch(exec){
      this.toastr.error('File upload failed!', '', {timeOut: 3000});
    }

  }

  deleteAttachment(index){

    this.commentAttachmentName.splice(index, 1)
    this.commentAttachment.splice(index, 1)
    this.commentToltipName.splice(index, 1)
   
  }

}
